import * as Types from '../../../generated/webapp_gql';

import { CirclesScreenNodeSectionFragment, CircleLink_CircleCircleTopicLinkNode_Fragment, CircleLink_CircleLanguageLinkNode_Fragment, CircleLink_CircleOnDemandLinkNode_Fragment } from './circlesLanguageOverviewScreen.generated';
import { CircleTopicBaseFragment, CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment, CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment, CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment, CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment, CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment, CircleFacilitatorFragment } from '../../../generated/circlesFragments.generated';
import { gql } from 'graphql.macro';
import { CirclesScreenNodeSectionFragmentDoc, CircleLinkFragmentDoc } from './circlesLanguageOverviewScreen.generated';
import { CircleTopicBaseFragmentDoc, CircleRsvpQuestionFragmentDoc, CircleFacilitatorFragmentDoc } from '../../../generated/circlesFragments.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type CirclesOnDemandScreenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CirclesOnDemandScreenQuery = (
  { __typename?: 'Query' }
  & { circlesOnDemandOverviewScreen?: Types.Maybe<{ __typename: 'CirclePermissionDeniedError' } | (
    { __typename?: 'CirclesOnDemandOverviewScreenNode' }
    & Pick<Types.CirclesOnDemandOverviewScreenNode, 'id' | 'name' | 'description'>
    & { sections: Array<Types.Maybe<(
      { __typename?: 'CircleScreenSectionNode' }
      & CirclesScreenNodeSectionFragment
    )>> }
  )> }
);


export const CirclesOnDemandScreenDocument = gql`
    query circlesOnDemandScreen {
  circlesOnDemandOverviewScreen {
    ... on CirclePermissionDeniedError {
      __typename
    }
    ... on CirclesOnDemandOverviewScreenNode {
      id
      name
      description
      sections {
        ...CirclesScreenNodeSection
      }
    }
  }
}
    ${CirclesScreenNodeSectionFragmentDoc}
${CircleLinkFragmentDoc}
${CircleTopicBaseFragmentDoc}
${CircleRsvpQuestionFragmentDoc}
${CircleFacilitatorFragmentDoc}`;

/**
 * __useCirclesOnDemandScreenQuery__
 *
 * To run a query within a React component, call `useCirclesOnDemandScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCirclesOnDemandScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCirclesOnDemandScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useCirclesOnDemandScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CirclesOnDemandScreenQuery, CirclesOnDemandScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CirclesOnDemandScreenQuery, CirclesOnDemandScreenQueryVariables>(CirclesOnDemandScreenDocument, options);
      }
export function useCirclesOnDemandScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CirclesOnDemandScreenQuery, CirclesOnDemandScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CirclesOnDemandScreenQuery, CirclesOnDemandScreenQueryVariables>(CirclesOnDemandScreenDocument, options);
        }
export type CirclesOnDemandScreenQueryHookResult = ReturnType<typeof useCirclesOnDemandScreenQuery>;
export type CirclesOnDemandScreenLazyQueryHookResult = ReturnType<typeof useCirclesOnDemandScreenLazyQuery>;
export type CirclesOnDemandScreenQueryResult = ApolloReactCommon.QueryResult<CirclesOnDemandScreenQuery, CirclesOnDemandScreenQueryVariables>;